import storage from 'utils/storage'
import signin from '../signin'
import entities from 'entities'
import { getSystemToken } from '../../utils/systemTokens'

const startSession = ({ user, lead_id }) => {
  const headers = {
    SystemToken: getSystemToken(),
  }

  const userFormatted = entities.User(user)

  return signin().then(({ http }) => {
    return http
      .post(`system/start_session/`, { ...userFormatted, lead_id }, { headers })
      .then(({ session_id, token }) => {
        storage.session.setItem('session_token', token)
        storage.session.setItem('session_id', session_id)
        return session_id
      })
  })
}

const leads = ({ user, userAnalytics }) => {
  const headers = {
    SystemToken: getSystemToken(),
  }

  const userFormatted = entities.User(user)

  return signin()
    .then(({ http }) => {
      return http
        .post(
          `leads/`,
          { ...userFormatted, analytics: userAnalytics },
          { headers }
        )
        .then((res) => {
          if (res) {
            storage.session.setItem('session_token', res?.token)
          }

          return res
        })
        .catch((e) => {
          console.error('signin error-', e)
        })
    })
    .catch((error) => {
      console.error('leads error -', error)
    })
}

const hasDebts = ({ user }) => {
  const headers = {
    SystemToken: getSystemToken(),
  }

  const userFormatted = entities.User(user)

  return signin()
    .then(({ http }) => {
      return http
        .get(
          `system/has_debts/?document_number=${userFormatted.document_number}&birthdate=${userFormatted.birth_date}`,
          { headers }
        )
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('hasDebts signin error-', e)
        })
    })
    .catch((error) => {
      console.error('hasDebts error -', error)
    })
}

const updateSourceUrl = ({ last_source_url }, token) => {
  const headers = {
    SystemToken: getSystemToken(),
  }

  return signin('analytics')
    .then(({ http }) => {
      http.defaults.headers['Token'] = `Bearer ${token}`
      return http
        .put('last_source_url/', { last_source_url }, { headers })
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('analytics signin error-', e)
        })
    })
    .catch((error) => {
      console.error('updateSourceUrl error -', error)
    })
}

const addAnalyticsInfo = (
  {
    source_url,
    referrer_url,
    user_agent,
    google_id,
    facebook_click_id,
    facebook_browser_id,
    anonymous_id,
    analytics_uuid,
  },
  token
) => {
  const userAnalytics = {
    source_url,
    referrer_url,
    user_agent,
    google_id,
    facebook_click_id,
    facebook_browser_id,
    anonymous_id,
    analytics_uuid,
  }

  return signin('')
    .then(({ http }) => {
      http.defaults.headers['Token'] = `Bearer ${token}`
      return http
        .post('leads/analytics', { analytics: userAnalytics })
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('addAnalyticsInfo signin error-', e)
        })
    })
    .catch((error) => {
      console.error('addAnalyticsInfo error -', error)
    })
}

export default {
  startSession,
  hasDebts,
  leads,
  updateSourceUrl,
  addAnalyticsInfo,
}
